
import  axios  from "axios";
import Cookies from "js-cookie";

const token = Cookies.get("authToken");

const headers={
   Authorization: `Bearer ${token}`
}


const url = "https:" + window.process.env.API_HOST_GLOBAL
const urlVideo = window.process.env.VIDEO_API;


export const PostData = async (path, data, header) => {
  return await axios.post(`${url}${path}`, data, {headers});
};
export const GetData = async (path, da) => {
  return await axios.get(`${url}${path}`,{
    headers
  });
};
export const DeleteData = async (path) => {
  return await axios.delete(`${urlVideo || url}${path}`, {headers});
};
export const UpdateData = async (path, data) => {
  return await axios.put(`${url}${path}`, data, {headers});
};
export const SendAccess = async (path, sessionId, action) => {
  try {
    return await axios.post(`${url}${path}`, {
      EmpStatsQuery : {
        session_id: sessionId,
        action: action,
      }

    },{headers});
  } catch (e) {
    console.error("ERROR Send access :", e);
  }
};

